import getApi from '../../../api'
import { StellairVitalCardInfos } from '../../../model/Stellair'

export const getStellairVitalCardInfos = () =>
  getApi().get<StellairVitalCardInfos>(`/stellair/vitale`)
